<div class="wrapper">
  <div class="list-wrapper">
    @for (floor of floors; track floor) {
      <div class="floor">
        @if (floor.floorIndex > 1) {
          <h2 class="header">{{ floor.floorIndex }} trappor</h2>
        }
        @if (floor.floorIndex === 1) {
          <h2 class="header">{{ floor.floorIndex }} trappa</h2>
        }
        @if (floor.floorIndex === 0) {
          <h2 class="header">Entréplan</h2>
        }
        @if (floor.floorIndex === -1) {
          <h2 class="header">{{ floor.floorIndex }} trappa ner</h2>
        }
        @if (floor.floorIndex < -1) {
          <h2 class="header">{{ floor.floorIndex }} trappor ner</h2>
        }
        <div class="rows">
          @for (row of floor.apartments; track row) {
            <div class="row">
              <div class="col-3 col-sm-2">
                <span>{{ row.apartmentNumber }}</span>
              </div>
              <div class="col-9 col-sm-10">
                <span class="nameplate">{{ row.nameplate }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
